// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__30vY9","inner":"Form_inner__2Vdu3","range":"Form_range__38wAz","name":"Form_name__3nZi7","actions":"Form_actions__5VmyC"};